import { render, staticRenderFns } from "./grouplist.vue?vue&type=template&id=1fefc0ec&scoped=true&"
import script from "./grouplist.vue?vue&type=script&lang=js&"
export * from "./grouplist.vue?vue&type=script&lang=js&"
import style0 from "./grouplist.vue?vue&type=style&index=0&id=1fefc0ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fefc0ec",
  null
  
)

export default component.exports